import { Popup } from '../Popups';

export interface IAction {
    function: (...args: Array<unknown>) => void;
    args: Array<unknown>;
}

export interface IPopupEntry {
    type: Popup;
    openAction: IAction;
}

export class PopupQueue {
    public get length() {
        return this.actionQueue.length + (this.active ? 1 : 0);
    }

    public get current() {
        return this.active;
    }

    private active: IPopupEntry;
    private actionQueue: IPopupEntry[] = [];

    public queue(entry: IPopupEntry) {
        if (!entry) {
            return false;
        }
        this.actionQueue.push(entry);
        const execute = !this.active;
        if (execute) {
            this.processQueue();
        }
        return execute;
    }

    public processQueue() {
        this.active = this.actionQueue.shift();
        const empty = !this.active;
        if (!empty) {
            const { function: openFunction, args: openArgs } = this.active.openAction;
            openFunction(...openArgs);
        }
        return empty;
    }
}
